module.exports = {
  siteTitle: '神社Map-全国神社巡りの思い出収集', // <title>
  manifestName: 'ss-map-lp',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#EB6101',
  manifestThemeColor: '#EB6101',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/ss-map-lp/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/Slowhand0309',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/wes_ja0927',
    }
  ],
};
